<template>
  <div class="cart-item" v-if="datas" :class="{ 'is-loading': isLoading, 'is-card': datas.cardOrderItem }">
    <div class="cart-item-wrapper">
      <p class="cart-item-flag" v-if="datas.bulk">{{ Translator('front.cart.item.grouped') }}</p>
      <p class="cart-item-index">{{ index + 1 }}</p>
      <div class="cart-item-media">
        <div class="cart-item-image" v-if="datas.cardOrderItem">
          <p class="cart-item-type" :style="itemTypeColor">{{ Translator('front.cart.item.type_' + datas.cardOrderItem.serviceType) }}</p>
          <img :src="datas.cardOrderItem.game.image.url" :alt="datas.cardOrderItem.game.name" v-if="datas.cardOrderItem.game && datas.cardOrderItem.game.image">
        </div>
        <div class="cart-item-image" v-else>
          <img :src="datas.variant.image.file.url" :alt="datas.variant.name" v-if="datas.variant.image && datas.variant.image.file && datas.variant.image.file.url">
        </div>
      </div>
      <div class="cart-item-informations">
        <p class="cart-item-name" v-if="datas.cardOrderItem">{{ datas.cardOrderItem.name }}</p>
        <p class="cart-item-name" v-else>{{ datas.variant.product.name }}</p>
        <ul class="cart-item-properties" v-if="datas.cardOrderItem">
          <li class="cart-item-property">{{ datas.cardOrderItem.language.code }}</li>
          <li class="cart-item-property" v-if="datas.cardOrderItem.year">{{ datas.cardOrderItem.year }}</li>
          <li class="cart-item-property" v-if="datas.cardOrderItem.extension">{{ datas.cardOrderItem.extension.name }}</li>
          <li class="cart-item-property" v-if="datas.cardOrderItem.extensionCode">{{ datas.cardOrderItem.extensionCode.name }}</li>
          <li class="cart-item-property" v-if="datas.cardOrderItem.languageCodeYGO">{{ datas.cardOrderItem.languageCodeYGO.value }}</li>
          <li class="cart-item-property" v-if="datas.cardOrderItem.additionnalLetterYGO">{{ datas.cardOrderItem.additionnalLetterYGO.value }}</li>
          <li class="cart-item-property" v-if="datas.cardOrderItem.customExtensionNumber">{{ datas.cardOrderItem.customExtensionNumber }}</li>
        </ul>
        <ul class="cart-item-specialities" v-if="datas.cardOrderItem && datas.cardOrderItem.specificities && datas.cardOrderItem.specificities.length > 0">
          <li class="cart-item-speciality" v-for="speciality in datas.cardOrderItem.specificities" :key="speciality.id">{{ speciality.name }}</li>
        </ul>
      </div>
      <div class="cart-item-side">
        <p class="cart-item-price" v-if="datas.cardOrderItem" v-html="Translator('front.cart.item.insurance', {value: (datas.cardOrderItem.value / 100).toFixed(2)})"></p>
        <div class="cart-item-quantity" v-else>
          <button type="button" class="cart-item-quantity-button" @click="onQuantityMinus" :disabled="datas.quantity <= 1">-</button>
          <div class="cart-item-quantity-group">
            <label>{{ Translator('front.cart.item.quantity') }}</label>
            <input type="text" :value="datas.quantity" class="cart-item-quantity-input" @change="onChangeQuantity" @keyup="onChangeQuantity">
          </div>
          <button type="button" class="cart-item-quantity-button" @click="onQuantityPlus">+</button>
        </div>
        <div class="cart-item-total">
          <p class="cart-item-total-value">
            <template v-if="displayedHt">{{ (datas.undiscountedTotalHt /100) | toFixed(2) }} € <sup>{{ Translator('front.cart.price_ht') }}</sup></template>
            <template v-else>{{ (datas.undiscountedTotalTtc /100) | toFixed(2) }} €</template>
          </p>
          <div v-if="datas.cardOrderItem">
            <p class="cart-item-no-insurance" v-if="!datas.cardOrderItem.insurance">{{ Translator('front.cart.item.without_insurance') }}</p>
            <div class="cart-item-insurance" v-else>
              <p class="cart-item-insurance-value">{{ Translator('front.cart.item.value_insurance', {value: (datas.cardOrderItem.value * 2 / 100 / 100).toFixed(2) }) }}</p>
              <p class="cart-item-insurance-mark"><i class="ico ico-check"></i> {{ Translator('front.cart.item.with_insurance') }}</p>
            </div>
          </div>
        </div>
        <div class="cart-item-actions">
          <template v-if="!datas.bulk">
            <button type="button" class="cart-item-action" @click="onCopy" v-if="datas.cardOrderItem" :title=" Translator('front.cart.item.copy_label', {name: datas.cardOrderItem ? datas.cardOrderItem.game.name : datas.variant.product.name}) ">
              <i class="ico ico-copy"></i>
              <span class="hide-access" v-if="datas.cardOrderItem">{{ Translator('front.cart.item.copy_label', {name: datas.cardOrderItem.game.name}) }}</span>
              <span class="hide-access" v-else>{{ Translator('front.cart.item.copy_label', {name: datas.variant.product.name}) }}</span>
            </button>
            <button type="button" class="cart-item-action" @click="onEdit" v-if="datas.cardOrderItem" :title=" Translator('front.cart.item.edit_label', {name: datas.cardOrderItem ? datas.cardOrderItem.game.name : datas.variant.product.name}) ">
              <i class="ico ico-edit"></i>
              <span class="hide-access" v-if="datas.cardOrderItem">{{ Translator('front.cart.item.edit_label', {name: datas.cardOrderItem.game.name}) }}</span>
              <span class="hide-access" v-else>{{ Translator('front.cart.item.edit_label', {name: datas.variant.product.name}) }}</span>
            </button>
          </template>
          <button type="button" class="cart-item-action" @click="onDelete" :title=" Translator('front.cart.item.delete_label', {name: datas.cardOrderItem ? datas.cardOrderItem.game.name : datas.variant.product.name}) ">
            <i class="ico ico-trash"></i>
            <span class="hide-access" v-if="datas.cardOrderItem">{{ Translator('front.cart.item.delete_label', {name: datas.cardOrderItem.game.name}) }}</span>
            <span class="hide-access" v-else>{{ Translator('front.cart.item.delete_label', {name: datas.variant.product.name}) }}</span>
          </button>
        </div>
      </div>
      <p class="cart-item-error" v-if="error">{{ error }}</p>
    </div>
    <div class="cart-item-options" v-if="datas.options.length > 0">
      <div class="cart-item-option" v-for="option in datas.options" :key="option.id">
        <p class="cart-item-option-label">{{ option.variant.name }}</p>
        <p class="cart-item-option-value">
          <template v-if="displayedHt">{{ (option.undiscountedTotalHt /100) | toFixed(2) }} € <sup>{{ Translator('front.cart.price_ht') }}</sup></template>
          <template v-else>{{ (option.undiscountedTotalTtc /100) | toFixed(2) }} €</template>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import debounce from 'debounce';
import AppControlService from '@/services/AppControl';
import OrdersService from '@/services/Orders';
import ModalService from '@/services/Modal';
import moment from 'moment';

export default {
  props: ['datas', 'index'],
  name: 'cart-item',
  data () {
    return {
      cart: OrdersService.cart,
      isLoading: false,
      error: null
    }
  },
  created() {
    OrdersService.on('updated', this._onUpdateCart);
  },
  destroyed() {
    OrdersService.off('updated', this._onUpdateCart);
  },
  mounted() {
    this.previousQuantity = this.datas.quantity;
  },
  computed: {
    itemTypeColor() {
      if (this.datas.cardOrderItem.serviceType === "authentication") {
        return { color: '#DBA800 ' }
      } else if (this.datas.cardOrderItem.serviceType === "re_evaluation") {
        return { color: '#2699B4' }
      } else {
        return { color: '#557084'}
      }
    },
    displayedHt: function() {
      return this.cart?.displayedHt;
    }
  },
  methods: {
    onEdit() {
      AppControlService.openAddCard(this.datas);
    },

    onCopy() {
      AppControlService.openAddCard(this.datas, true);
    },

    onQuantityMinus() {
      this.datas.quantity -= 1;
      this._updateQuanty();
    },

    onQuantityPlus() {
      this.datas.quantity += 1;
      this._updateQuanty();
    },

    onChangeQuantity(pEvt) {
      let value = parseInt(pEvt.target.value);
      if( isNaN(value) || value === this.datas.quantity) return;
      if( value === 0 ) value = 1;
      this.datas.quantity = value;
      this._updateQuanty();
    },

    onDelete() {
      if(this.isLoading) return;
      this.isLoading = true;
      const deleteItem = () => {
        OrdersService.deleteItem(this.datas.id).then( () => {
          OrdersService.get().then().then( () => {
            this.isLoading = false;
          })
        }).catch(err => {
          console.error(err);
        });
      }
      const deleteWithoutConfirmation = window.localStorage.getItem('delete-without-confirmation');
      const now = moment();
      if(deleteWithoutConfirmation) {
        if (now.diff( moment(deleteWithoutConfirmation), 'minutes' ) < 10) return deleteItem();
        window.localStorage.removeItem('delete-without-confirmation')
      }
      ModalService.open({
        content: window.Translator.trans('front.cart.item.delete_confirm'),
        checkbox:  window.Translator.trans('front.cart.item.delete_checkbox')
      }).then( (datas) => {
        if(datas.disableConfirmation) window.localStorage.setItem('delete-without-confirmation', now.format());
        deleteItem();
      }).catch((err) => {
        if(err) console.error(err);
        this.isLoading = false;
      })
    },

    _updateQuanty: debounce( function() {
      if(this.isLoading) return;
      this.isLoading = true;
      OrdersService.updateItem(this.datas.id, {quantity: this.datas.quantity}).then( () => {
        this.previousQuantity = this.datas.quantity;
        OrdersService.get().then().then( () => {
          this.isLoading = false;
        })
      }).catch( (err) => {
        this.isLoading = false;
        this.datas.quantity = this.previousQuantity;
        if(err.response && err.response.data && err.response.data['hydra:description']) {
          this.error = err.response.data['hydra:description'];
          setTimeout(() => {
            this.error = null;
          }, 3000);
        }
      });
    }, 500),

    _onUpdateCart(res) {
      this.cart = res;
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    },
  }
};
</script>
<style scoped lang="scss"></style>
